<template>
    <div class="live-notifications">
        <!-- This component is used for real-time notifications via Echo -->
    </div>
</template>

<script>
import { mapState } from 'vuex';

import BellNotification from '@/models/BellNotification.js';

export default {
    name: 'LiveNotifications',

    computed: {
        ...mapState('Auth', { user: state => state.user }),

        echoReady() {
            return !!this.$store.state.Online.$echo;
        },

        page() {
            return this.$store.state.entities.bell_notifications.page;
        },
    },

    watch: {
        echoReady: {
            handler(ready) {
                if (ready) {
                    this.$echo
                        .private(`notifications-${this.user.id}`)
                        // New notifications arriving.
                        .listen('.notification', () => BellNotification.fetch(this.page))
                        // Read/unread changes (e.g. marking read from the inbox) must also
                        // refresh the bell counter live, not only after a page reload.
                        .listen('ModelReadStatusChanged', () => BellNotification.fetch(this.page));
                }
            },
            immediate: true,
        },
    },
    mounted() {
        BellNotification.fetch(this.page);
    },

    methods: {
        async fetchNotifications() {
            await BellNotification.fetch(this.page);
        },
    },
};
</script>

<style scoped>
.live-notifications {
    display: none; /* Hidden component used only for real-time functionality */
}
</style>
